<template>
    <div class="vrm-remote-console-choice-container">
        <div class="vrm-remote-console-choice-container__header">
            <div class="vrm-remote-console-choice-container__title">
                {{
                    $t('remoteconsole.choose_ui_title', {
                        i18nFallback: 'Choose your Remote Console UI',
                    })
                }}
            </div>
        </div>
        <div class="vrm-remote-console-choice-container__content">
            <div class="vrm-remote-console-choice-container__select">
                <vrm-remote-console-choice
                    :selected-console="selected"
                    :loading="saving"
                    @change="onSelectionChanged"
                ></vrm-remote-console-choice>
            </div>

            <div class="vrm-remote-console-choice-container__footer">
                <div class="vrm-remote-console-choice-container__footer-left">
                    <div
                        class="vrm-remote-console-choice-container__save vrm-fieldset__item sg-custom-check-and-radio sg-custom-check"
                    >
                        <label class="vrm-fieldset__item__label sg-textfield-label">
                            <input id="remember" v-model="remember" type="checkbox" />

                            <div class="sg-alternative-display">
                                <div class="sg-icon-check" />
                            </div>
                        </label>

                        <label for="remember" class="additional-label">
                            {{
                                $t('remoteconsole.choose_ui_remember_choice', {
                                    i18nFallback: "Don't show again",
                                })
                            }}
                        </label>
                    </div>
                </div>

                <div class="vrm-remote-console-choice-container__footer-right">
                    <span
                        v-html="
                            $t('remoteconsole.choose_ui_read_more', {
                                i18nFallback:
                                    'To learn more ut the new UI, read <a href=\'https://ve3.nl/gx-nui-vrm\' target=\'_blank\'>here</a>',
                            })
                        "
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmRemoteConsoleChoice from '@/vue/components/shared/VrmRemoteConsoleChoice.vue';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';

@Component({
    components: { VrmRemoteConsoleChoice },
})
@AngularDirective('vrm-remote-console-choice-container')
@AngularLocaleBundle('modal')
@AngularLocaleBundle('remoteconsole')
export default class VrmRemoteConsoleChoiceContainer extends Vue {
    @ngInject()
    ApiService;

    @ngInject()
    $rootScope;

    @ngInject()
    $stateParams;

    @Prop({ type: Number, required: false })
    idSite;

    @Prop({ type: Function, required: false })
    onSelected;

    remember = false;
    selected = null;
    saving = false;

    get effectiveIdSite() {
        return this.idSite || (this.$stateParams && this.$stateParams.id);
    }

    onSelectionChanged(e) {
        this.selected = e;

        if (this.remember) {
            this.onSubmit();
        } else {
            window.dispatchEvent(
                new CustomEvent('remote-console-choice-selected', {
                    detail: this.selected,
                }),
            );

            this.$emit('choice-selected', this.selected);
            if (this.onSelected) {
                this.onSelected(this.selected);
            }
        }
    }

    async onSubmit() {
        if (this.remember) {
            this.saving = true;

            if (!this.effectiveIdSite) {
                console.error('VrmRemoteConsoleChoiceContainer: idSite is undefined or null');
                this.saving = false;
                return;
            }

            try {
                const response = await this.ApiService.setRemoteConsolePreference(
                    this.effectiveIdSite,
                    this.selected,
                );

                if (!response || !response.data || !response.data.success) {
                    this.saving = false;
                    return;
                }

                this.$rootScope.$broadcast('rc-changed', this.selected);
            } catch (e) {
                this.saving = false;
                return;
            }
        }

        if (this.selected) {
            window.dispatchEvent(
                new CustomEvent('remote-console-choice-selected', {
                    detail: this.selected,
                }),
            );

            this.$emit('choice-selected', this.selected);

            if (this.onSelected) {
                this.onSelected(this.selected);
            }
        }
    }
}
</script>
